<template>
    <div class="loading-indicator" :style="{ height: height, width: width }">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</template>

<script>
export default {
    name: 'pw-c-loading-indicator',
    props: {
        height: {
            type: String,
            default: '48px'
        }
    },
    computed: {
        width() {
            return this.height.replace('px', '') / 6 * 7 + 'px';
        }
    }
};
</script>

<style lang="scss" scoped>
    @import "../assets/scss/pwTheme/functions";
    @import "../assets/scss/pwTheme/colors";
    @keyframes wobble {
        0%,
        30% {
            transform: scaleY(1);
        }
        100% {
            transform: scaleY(3);
        }
    }

    .loading-indicator {
        height: 48px;
        width: 56px;
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        vertical-align: middle;
    }

    .loading-indicator > * {
        height: 33.333%;
        background-color: pwColor('cerulean');
        flex: 0 0 14.286%;
    }

    // common
    .loading-indicator > * {
        transform-origin: 50% 50%;
        animation: wobble 0.5s ease-in-out infinite alternate;
    }

    .loading-indicator > *:nth-child(2) {
        animation-delay: 0.1s;
    }
    .loading-indicator > *:nth-child(3){
        animation-delay: 0.2s;
    }
    .loading-indicator > *:nth-child(4) {
        animation-delay: 0.3s;
    }
    .loading-indicator > *:nth-child(5) {
        animation-delay: 0.4s;
    }
</style>
